// router/index.ts
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: "/splash",
  },
  // {
  //   path: "/",
  //   name: "test",
  //   component: () => import("@/components/Test.vue"),
  // },
  {
    path: "/splash",
    name: "splash",
    component: () => import("@/components/Splash.vue"),
  },
  {
    path: "/lms",
    name: "lms",
    component: () => import("@/components/LMS/StudentList.vue"),
  },
  {
    path: "/lms/students/:id",
    name: "StudentDetail",
    component: () => import("@/components/LMS/StudentDetail.vue"),
  },
  {
    path: "/main",
    name: "main",
    component: () => import("@/components/main/MainFrame.vue"),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      if (from.name !== "splash") {
        next({ name: "splash", query: { redirect: "main" } });
      } else {
        next();
      }
    }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 이전 경로 추적용
let prevRouterPath: string;
router.beforeEach((to, from, next) => {
  prevRouterPath = from.fullPath;
  next();
});

export { router, prevRouterPath };
